 export default function Footer() {
    const currentYear = new Date().getFullYear();
  
    return (
      <footer className="bg-[#0c1e5b] border-t border-gray-700">
        <div className="max-w-7xl mx-auto py-8 px-6 lg:px-8">
          <div className="max-w-7xl mx-auto px-4 lg:px-4 text-center">
            <p className="text-sm  text-gray-400 text-center">
              &copy; {currentYear} MNR Technologies Global Pvt Ltd. All Rights Reserved.
            </p>
          </div>
        </div>
      </footer>
    );
  }